module.exports = __webpack_public_path__ + "img/webService.6225e7b5.png";